import Heading from './heading';

// eslint-disable-next-line unicorn/prefer-export-from
export { Heading };
